import BaseModel from "../core/BaseModel";
export default class AtwModel extends BaseModel {
  constructor() {
    super(
      {
        name: "atw",
        tableName: "atw",
        label: "Giấy phép làm việc (ATW)",
        display_key: "name",
      },
      {
        stt: { 
          name: "stt", 
          label: "STT",
          class: 'center', 
          computed: (data, index) => {
            data.stt = index + 1;
          }
        },
        id: { 
          name: 'id', 
          type: "Uuid", 
          label: 'ID', 
          primaryKey: true,
          display: false
        },

        code: {
          name: "code",
          type: "CustomUrl",
          label: "Mã giấy phép",
          style : "width:100px;",
          filter: { type: "input", match: "contains" },
        },
        sra_name: {
          name: "sra_name",
          type: "String",
          label: "Gói công việc",
          minWidth : 10,
          filter: { type: "input", match: "contains" },
        },
        contractor_name: {
          name: "contractor_name",
          type: "String",
          label: "Nhà thầu",
          minWidth : 10,
          filter: { type: "input", match: "contains" },
        },
        time_atw: {
          name: "time_atw",
          type: "String",
          label: "Hiệu lực giấy phép",
          // width: 6,
          filter: { type: 'DateRange', match: 'contains'},
        },
        text_supervisor: {
          name: "text_supervisor",
          type: "String",
          label: "Giám sát",
          minWidth : 10,
          filter: { type: "input", match: "contains" },
        },
        status: {
          name: "status",
          label: "Trạng thái",
          type: "Selection",
          custom: 'SelectionText',
          class: "center",
          options: [
            { value: "WAITTING", label: "Chờ duyệt"},
            { value: "APPROVED_LV1", label: "Duyệt cấp 1" },
            { value: "APPROVED", label: "Đã duyệt" },
            { value: "EXTEND_WAITTING", label: "Chờ duyệt gia hạn" },
            { value: "EXTEND_LV1", label: "Đã duyệt gia hạn 1 cấp" },
            { value: "EXTEND", label: "Đã gia hạn" },
            { value: "DONE_WAITTING", label: "Chờ duyệt hoàn thành" },
            { value: "DONE_LV1", label: "Duyệt hoàn thành cấp 1" },
            { value: "DONE", label: "Hoàn thành" },
            { value: "CLOSE_WAITTING", label:"Chờ duyệt đóng ATW"},
            { value: "CLOSE_LV1", label: "Duyệt đóng 1 cấp" },
            { value: "CLOSE", label: "Đã đóng" },
            { value: "WITHDRAW_WAITTING", label: "Chờ duyệt rút giấy phép" },
            { value: "WITHDRAW_LV1", label: "Đã duyệt rút 1 cấp" },
            { value: "WITHDRAW", label: "Rút giấy phép" },
            { value: "REJECTED", label: "Từ chối duyệt" },
            { value: "REJECTED_EXTEND", label: "Từ chối gia hạn" },
            { value: "REJECTED_WITHDRAW", label: "Từ chối rút giấy phép" },
            { value: "REJECTED_CLOSE", label: "Từ chối đóng" },
            { value: "REJECTED_DONE", label: "Từ chối duyệt hoàn thành" },
          ],
          filter: {
            type: "select",
            optionLabel: "label",
            optionKey: "value",
            match: "equals",
          },
        },
        updated_fullname: {
          refs:"updated_fullname",
          type: "String",
          label: "Người cập nhật"
        },
        updated_at: {
          name: "updated_at",
          type: "Datetime",
          label: "Cập nhật cuối"
        },
      }
    );
  }
}
